module.exports = __webpack_public_path__ + "b5b7b9c7f578634851dea52a8771d607.png";